export const MAX_ALLOWED_QUANTITY = 9;

export const SUPPORTED_CURRENCIES = ['aud', 'cad', 'usd'];

export const PRODUCT_IMAGES = {
  RAY: require('../assets/img/ray_small.png'),
  ADAPTER: require('../assets/img/adapter.png'),
  SUBSCRIPTION: require('../assets/img/subscription.png')
};

export const CHARGEBEE_SUBSCRIPTION_PLANS = {
  AUD: [
    { id: 'gofar_unlimited_monthly_1', price: 1500, name: 'Monthly Unlimited Plan' },
    { id: 'gofar_unlimited_yearly_1', price: 13200, name: 'Annual Unlimited Plan' },
    { id: 'gofar_unlimited_bi_yearly', price: 21600, name: '2 Year Unlimited Plan' }
  ],
  USD: [
    { id: 'gofar_unlimited_monthly_1_usd', price: 1050, name: 'Monthly Unlimited Plan' },
    { id: 'gofar_unlimited_yearly_1_usd', price: 9250, name: 'Annual Unlimited Plan' },
    { id: 'gofar_unlimited_bi_yearly_usd', price: 15150, name: '2 Year Unlimited Plan' }
  ],
  CAD: [
    { id: 'gofar_unlimited_monthly_1_cad', price: 1400, name: 'Monthly Unlimited Plan' },
    { id: 'gofar_unlimited_yearly_1_cad', price: 12200, name: 'Annual Unlimited Plan' },
    { id: 'gofar_unlimited_bi_yearly_cad', price: 20000, name: '2 Year Unlimited Plan' }
  ]
};

export const CHARGEBEE_ADD_ONS = {
  AUD: [
    { id: 'gofar_adapter_1', price: 10000, name: 'GOFAR Adapter', imageUrl: PRODUCT_IMAGES.ADAPTER },
    { id: 'gofar_ray', price: 4900, name: 'GOFAR Ray', imageUrl: PRODUCT_IMAGES.RAY }
  ],
  USD: [
    {
      id: 'gofar_adapter_1_usd',
      price: 7000,
      name: 'GOFAR Adapter',
      imageUrl: PRODUCT_IMAGES.ADAPTER
    },
    { id: 'gofar_ray_usd', price: 3450, name: 'GOFAR Ray', imageUrl: PRODUCT_IMAGES.RAY }
  ],
  CAD: [
    {
      id: 'gofar_adapter_1_cad',
      price: 9300,
      name: 'GOFAR Adapter',
      imageUrl: PRODUCT_IMAGES.ADAPTER
    },
    { id: 'gofar_ray_cad', price: 4500, name: 'GOFAR Ray', imageUrl: PRODUCT_IMAGES.RAY }
  ]
};

export const SHIPPING_OPTIONS = {
  AUSTRALIA_POST: {
    id: 'shipping-australia-post',
    name: 'AusPost Snail Mail',
    delivery_days: '6-10',
    has_tracking: false,
    price: 0,
    currency: 'AUD'
  },
  AUSTRALIA_POST_EXPRESS: {
    id: 'shipping-australia-post-express',
    name: 'Priority Business',
    delivery_days: '2-4',
    has_tracking: true,
    price: 0,
    currency: 'AUD'
  },
  INTERNATIONAL_SHIPPING: {
    id: 'international-shipping-with-tracking',
    name: 'International Shipping',
    delivery_days: '2-4',
    has_tracking: true,
    price: 1500,
    currency: 'AUD'
  },
  FREE_INTERNATIONAL_SHIPPING: {
    id: 'free-international-shipping-with-tracking',
    name: 'Priority Business',
    delivery_days: '3-5',
    has_tracking: true,
    price: 0,
    currency: 'AUD'
  },
  FREE_INTERNATIONAL_SHIPPING_CAD: {
    id: 'free-international-shipping-with-tracking-cad',
    name: 'Priority Business',
    delivery_days: '3-5',
    has_tracking: true,
    price: 0,
    currency: 'CAD'
  },
  FREE_INTERNATIONAL_SHIPPING_USD: {
    id: 'free-international-shipping-with-tracking-usd',
    name: 'Priority Business',
    delivery_days: '3-5',
    has_tracking: true,
    price: 0,
    currency: 'USD'
  }
};

export const COUNTRY_SETTINGS = {
  AU: {
    currencyCode: 'AUD',
    currencySymbol: '$',
    shippingOptions: [SHIPPING_OPTIONS.AUSTRALIA_POST_EXPRESS, SHIPPING_OPTIONS.AUSTRALIA_POST]
  },
  CA: {
    currencyCode: 'CAD',
    currencySymbol: '$',
    // as part of promotion, we are providing free shipping for canadian orders
    shippingOptions: [SHIPPING_OPTIONS.FREE_INTERNATIONAL_SHIPPING_CAD]
  },
  US: {
    currencyCode: 'USD',
    currencySymbol: '$',
    shippingOptions: [SHIPPING_OPTIONS.FREE_INTERNATIONAL_SHIPPING_USD]
  },
  DEFAULT: {
    currencyCode: 'AUD',
    currencySymbol: '$',
    shippingOptions: [SHIPPING_OPTIONS.INTERNATIONAL_SHIPPING]
  }
};
